import { Link } from 'react-router-dom';
import type { CharacterItem } from '@/types/content';
import { getElementStyle } from '@/utils/elements';
import FavoriteButton from './FavoriteButton';

export default function CharacterCard({ item }: { item: CharacterItem }) {
  const element = getElementStyle(item.element);

  return (
    <article className="gs-card-hover group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50">
      <div className="relative">
        <Link to={`/characters/${item.id}`} className="block cursor-pointer">
          <div className="h-52 w-full overflow-hidden bg-gradient-to-b from-primary-100 to-background-100">
            <img
              src={item.splash}
              alt={item.name}
              title={`${item.name} 角色攻略`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </Link>
        <span className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-label ${element.badge}`}>
          <i className={`${element.icon} text-xs`}></i>
          {element.label}
        </span>
        <div className="absolute right-3 top-3">
          <FavoriteButton id={`char-${item.id}`} />
        </div>
        <span className="absolute bottom-3 left-3 inline-flex items-center gap-0.5 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-accent-300 backdrop-blur-sm">
          {Array.from({ length: item.rarity }).map((_, index) => (
            <i key={`${item.id}-star-${index}`} className="ri-star-fill text-[11px]"></i>
          ))}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-base font-bold text-foreground-950">
            <Link to={`/characters/${item.id}`} className="cursor-pointer transition-colors hover:text-primary-700">
              {item.name}
            </Link>
          </h3>
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-label text-secondary-900">{item.roleName}</span>
        </div>
        <p className="mt-0.5 text-xs text-primary-700">{item.title}</p>
        <p className="mt-2 line-clamp-2 flex-1 text-sm text-foreground-600">{item.intro}</p>
        <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-sword-line"></i>
            {item.weapon}
          </span>
          <span className="inline-flex items-center gap-1 text-accent-700">
            <i className="ri-fire-line"></i>
            人气 {item.popularity}
          </span>
        </div>
      </div>
    </article>
  );
}